import i18n from "@/assets/lang";

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ["admin", "editor", "sanycloudAdmin"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} str
 * @returns {Boolean}
 * 验证手机号
 */
export function isPoneAvailable(poneInput) {
  const myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(poneInput)) {
    return false;
  } else {
    return true;
  }
}

/**
 * @param {string} str
 * @returns {Boolean}
 * 验证邮箱
 */
export function isEmailAvailable(emailInput) {
  const myreg =
    /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  if (!myreg.test(emailInput)) {
    return false;
  } else {
    return true;
  }
}

/**
 * @param {string} str
 * @returns {Boolean}
 * 验证字符长度不超过多少位（一个汉字是两个字符）
 */
export function strLengthCheck(str, min, max) {
  const reg = /^[\u4e00-\u9fa5A-Za-z\d\-]{1,}$/gi;
  if (reg.test(str)) {
    const len = str.replace(/[^\x00-\xff]/g, "aa").length;
    if (len < min || len > max) {
      return false;
    }
    return true;
  }
}

/* 社会信用代码 */
export function validatesocialCreditCode(rule, value, callback) {
  const reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10})$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectSocialCreditCode")));
  }
}

/* 手机号 */
export function validatePhone(rule, value, callback) {
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectPhoneNumber")));
  }
}

/* 固定电话 */
export function validateFixPhone(rule, value, callback) {
  const reg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error("请输入正确的电话号码"));
  }
}

/* QQ */
export function validateQQ(rule, value, callback) {
  const reg = /^[1-9][0-9]{4,10}$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error("请输入正确的QQ号"));
  }
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(rule, value, callback) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectEmail")));
  }
}

// 输入框内容不能全为空格
export function validateSpace(rule, value, callback) {
  const reg = /^(?!(\s+$))/;

  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("输入内容不能全为空格"));
  }
}

// IP
export function validateIp(rule, value, callback) {
  const reg =
    /^(([1-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.)(([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.){2}([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))$/;
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("IP格式错误"));
  }
}

// 端口号
export function validatePort(rule, value, callback) {
  const reg =
    /^([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;

  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("端口格式错误"));
  }
}

// 校验名称
export function validateIllegality(rule, value, callback) {
  const reg = /^[a-zA-Z0-9_\u4e00-\u9fa5-#*,.$()]+$/;
  if (!rule.isNull && value.trim() === "") {
    callback(new Error(`该项必填`));
    return;
  }
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error("请输入中英文、数字、-_#*,.$()"));
  }
}

// emoji表情校验
export function validEmoji(rule, value, callback) {
  const reg = /[\ud800-\udbff][\udc00-\udfff]/g;
  if (reg.test(value)) {
    callback(new Error("请勿输入表情符号"));
  } else {
    callback();
  }
}

// 校验数字包括小数 负数
export function validateNumdecimals(rule, value, callback) {
  // let reg = /^-?[1-9]*(\.\d*)?$|^-?0(\.\d*)?$/
  const reg = /^(\-|\+)?\d+(\.\d+)?$/g;
  if (!reg.test(value)) {
    callback(new Error(`值类型必须为数值`));
    return;
  }
  callback();
}

// 输入非负整数
export function validateNotNegative(rule, value, callback) {
  const reg = rule.isNegative ? /^(\-|\+)?\d+(\.\d+)?$/g : /^([1-9]\d*|0)$/;
  const res = reg.test(value);
  const val = rule.max || 999999;
  if (!rule.isNull && value === "") {
    callback(new Error(`该项必填`));
    return;
  }
  if (res) {
    if (Number(value) > val) {
      callback(new Error(`超出最大值${val}范围`));
      return;
    }
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(rule.isNegative ? "请输入数字" : "请输入非负整数"));
  }
}

// 正整数 isNegative(是否允许负数以及小数)
export function validateNumber(rule, value, callback) {
  const reg = rule.isNegative ? /^(\-|\+)?\d+(\.\d+)?$/g : /^[0-9]*[1-9][0-9]*$/;
  const res = reg.test(value);
  const maxValue = rule.max || 999999;
  const minValue = rule.min || 1;
  if (!rule.isNull && value === "") {
    callback(new Error(`该项必填`));
    return;
  }
  if (res) {
    if (Number(value) > maxValue) {
      callback(new Error(`最大值${maxValue}`));
      return;
    }
    if (Number(value) < minValue && Object.keys(rule).indexOf("min") >= 0) {
      callback(new Error(`最小值${minValue}`));
      return;
    }
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(rule.isNegative ? "请输入数字 !" : "请输入正整数"));
  }
}

/**
 * 校验非法字符并防止sql注入(仅为搜索使用)
 * @param {Object} param
 * @param {*} callback
 */
export function validateIllegalitySearch(param, callback) {
  const reg =
    param.reg || /((?![a-zA-Z0-9_\u4e00-\u9fa5-#*,.$()]).)|select|update|delete|exec|count/i;
  if (reg.test(param.value)) {
    return {
      type: false,
      message: `请您不要在${param.message || "参数"}中输入特殊字符或SQL关键字 !`
    };
  }
  return {
    type: true
  };
}

// 检查非中文
export function validateNoChinese(rule, value, callback) {
  const reg = /^[^\u4e00-\u9fa5]+$/;
  if (rule.noSpace) {
    if (!value.trim()) {
      callback(new Error("不支持输入内容为全部空格"));
    }
  }

  if (!reg.test(value)) {
    callback(new Error("不支持中文字符"));
  } else {
    if (rule._callback) {
      rule._callback(rule, value, callback);
      return;
    }
    callback();
  }
}
